// extracted by mini-css-extract-plugin
export default {"answerLabel":"W_cR","success":"W_cS"};